/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chatloadinghistory2Inputs */

const en_chatloadinghistory2 = /** @type {(inputs: Chatloadinghistory2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Loading conversation…`)
};

const pt_chatloadinghistory2 = /** @type {(inputs: Chatloadinghistory2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A carregar a conversa…`)
};

/**
* | output |
* | --- |
* | "Loading conversation…" |
*
* @param {Chatloadinghistory2Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const chatloadinghistory2 = /** @type {((inputs?: Chatloadinghistory2Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chatloadinghistory2Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_chatloadinghistory2(inputs)
	return pt_chatloadinghistory2(inputs)
});
export { chatloadinghistory2 as "chatLoadingHistory" }